module.exports = __webpack_public_path__ + "images/add_announcement.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/add_announcement.png
 ** module id = 49
 ** module chunks = 1
 **/